export default __webpack_public_path__ + "static/media/Thong bao 96_ Văn phòng Tỉnh uỷ Trà Vinh.b0042775.pdf";